import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDoor: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="door, login, logout"><path d="M2.75 21.25L21.25 21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.75 21.25V2.75H19.25V21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 12.25H8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconDoor;
